// @flow

import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./App.css";

import App from "./App.react";

const rootElement = document.getElementById("root");

if (rootElement) {
  ReactDOM.render(<App />, rootElement);
  // The static #initial-loader in index.html covers the blank flash before the JS bundle and
  // theme CSS finish loading - remove it now that React has actually mounted and can paint.
  const initialLoader = document.getElementById("initial-loader");
  if (initialLoader) {
    initialLoader.remove();
  }
} else {
  throw new Error("Could not find root element to mount to!");
}